import { Component, OnDestroy, OnInit, ViewChild, Renderer2 } from '@angular/core';
import {Subscription} from 'rxjs';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {ListData} from '../../Interfaces/ListData';
import {ContainerView} from '../../Interfaces/ContainerView';
import {User} from '../../Interfaces/User';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {QueryService} from '../../Services/query.service';
import {HoldsView} from '../../Interfaces/HoldsView';
import NumberFormatOptions = Intl.NumberFormatOptions;
import {HazardsView} from '../../Interfaces/HazardsView';
import * as XLSX from 'xlsx';
import {ContainerViewExcel} from '../../Interfaces/ContainerViewExcel';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-equipment-inquiry',
  templateUrl: './equipment-inquiry.component.html',
  styleUrls: ['./equipment-inquiry.component.css']
})
export class EquipmentInquiryComponent implements OnInit, OnDestroy {
  search1: UntypedFormControl;
  phoneApp: boolean = false;
  ipadApp: boolean = false;

  quickViewData: MatTableDataSource<ContainerView>;
  quickViewData2: MatTableDataSource<ContainerView>;
  hArray: HoldsView[] = [];
  hzArray: HoldsView[] = [];

  txtFromArea: string;
  submitted = false;
  oneIsInAlready = false;
  submitted2 = false;
  badContainer = false;
  txtArray2: string [] = [];
  subscription: Subscription;
  public didntEnterShit: boolean = false;
  public badChars: boolean = false;
  public insertNoConts: boolean = false;
  public insertListExists: boolean = false;
  public noListName: boolean = false;
  public showInquiry: boolean = true;
  public showQuickView: boolean = false;
  public showDetailScreen: boolean = false;
  public showHoldsInfo: boolean = false;
  public showReeferInfo: boolean = false;
  public showHazInfo: boolean = false;
  public showODInfo: boolean = false;
  public savedList: string;
  public containerNum: string;
  public savedLists: { id: string, code: string, description: string }[] = [];
  myNewListName: string = "";
  private contView: ContainerView[];
  private contViewExcelArray: ContainerViewExcel[] = [];
  private contViewExcel: ContainerViewExcel;
  private inqView: ContainerView[];
  private historyView: ContainerView[];
  private myUser: User;
  hold: HoldsView;
  haz: HazardsView;
  holdsData: MatTableDataSource<HoldsView>;
  hazData: MatTableDataSource<HazardsView>;

  private clientRequest: ClientRequest;
  cv: ContainerView;
  private listData: ListData[];
  private listDataObj: ListData;
  public qvColumns: string[];
  public qvColumns2: string[];
  public holdsColumns: string[];
  public hazColumns: string[];
  weight: string;
  currentIndx: number;
  hazardIndx: number;
  showAcc: boolean = false;
  private date1: Date;
  private number1: number;
  private options: Intl.DateTimeFormatOptions = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  };
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;
  private options2: NumberFormatOptions = {maximumFractionDigits: 2};
 sub: any;
  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData != undefined) {
      this.quickViewData.sort = sort;
    }
    if (this.quickViewData2 != undefined) {
      this.quickViewData2.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData != undefined) {
      this.quickViewData.paginator = pag;
    }

  }




  returnToSearch(){
    if (this.ipadApp){
      this.inSearch = false;
      this.ipadAppear = true;
      this.showQuickView = false;
    }
  }




  constructor(fb: UntypedFormBuilder, private router: Router, private service: SharedVarService, private myApp: AppComponent, private renderer: Renderer2, private  globalEventsManager: GlobalEventsManager, private  queryService: QueryService) {

    this.qvColumns = ["container", "fcy_description","line_id", "iso_description", "category_description", "freight_kind_description", "transit_state_description", "received_date_fmt", "delivered_date_fmt"];
    this.qvColumns2 = ["container","fcy_description", "line_id", "category_description", "freight_kind_description", "transit_state_description", "received_date_fmt", "delivered_date_fmt"];
    this.holdsColumns = ["type","code","description"];
    this.hazColumns = ["imdg_code","proper_name","hzrdi_nbr_type","quantity","package_type","weight","marine_pollutants","tech_name","un_num","flash_point","packing_group","emergency_telephone","notes"];


    this.sub =  this.service.getConfirmed().subscribe((value) => {
      if (value){
        this.updateContainerList('D');
        this.service.setConfirmed(false);
      }
    });




    this.myUser = this.myApp.user;

/*
    this.myUser = {} as User;
    this.myUser.active = "Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
    //this.myUser.company_code ="EGN"
    this.myUser.company_code = "M0995"
    this.myUser.company_name = "MAHER TERMINALS, LLC"
    this.myUser.city = "HOUSTON"
    this.myUser.email_address = "cmilller@maherterminals.com"
    this.myUser.fax_number = null
    this.myUser.first_name = "Csp Craig"
    this.myUser.last_name = "Miller"
    this.myUser.maherError = null
    this.myUser.old_password = null
    this.myUser.password = ""
    this.myUser.phone_number = null
    this.myUser.company_scac = null
    this.myUser.state = "TX"
    this.myUser.userMenuReportItemsView = null
    this.myUser.user_gkey = "8237887"
   this.myUser.role = "AGENT"
    //this.myUser.role= "LINEOP"
    // this.myUser.role= "HAULIER"
    this.myUser.username = "CDOUG"
    this.myUser.zip = "07201"
    this.myUser.canSeeAllData = "1";




 */


  }


  exportExcel() {
    this.quickViewData;
    this.contViewExcelArray = [];
    for (var xx=0; xx<this.quickViewData.filteredData.length; xx++){
      this.contViewExcel = {} as ContainerViewExcel ;
      this.contViewExcel.Container = this.quickViewData.filteredData[xx].container;
      this.contViewExcel.Facility = this.quickViewData.filteredData[xx].fcy_description;
      this.contViewExcel.SSL = this.quickViewData.filteredData[xx].line_id;
      this.contViewExcel.ISO = this.quickViewData.filteredData[xx].iso_description;
      this.contViewExcel.Category = this.quickViewData.filteredData[xx].category_description;
      this.contViewExcel.Freight = this.quickViewData.filteredData[xx].freight_kind_description;
      this.contViewExcel.Transit = this.quickViewData.filteredData[xx].transit_state_description;
      this.contViewExcel.Received = this.quickViewData.filteredData[xx].received_date_fmt;
      this.contViewExcel.Delivered = this.quickViewData.filteredData[xx].delivered_date_fmt;
      this.contViewExcelArray.push(this.contViewExcel);

    }

    this.contViewExcelArray.sort(function(a, b) {
      if (a.Container < b.Container) {
        return -1;
      }
      if (a.Container > b.Container) {
        return 1;
      }
      return 0;
    })

    const workSheet = XLSX.utils.json_to_sheet(this.contViewExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:15},
      {wch:10},
      {wch:10},
      {wch:25},
      {wch:10},
      {wch:10},
      {wch:10},
      {wch:30},
      {wch:30},
    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'EquipmentInquiry');
    XLSX.writeFile(workBook, 'equipmentInquiry.xlsx');
  }

  openReefer() {
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showReeferInfo = true;
    }, 400);
  }

  openHolds() {
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showHoldsInfo = true;
    }, 400);
  }

  openHazards() {
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showHazInfo = true;
    }, 400);
  }

  openOds() {
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showODInfo = true;
    }, 400);
  }

  clearAllInfo() {
    this.showHoldsInfo = false;
    this.showReeferInfo = false;
    this.showHazInfo = false;
    this.showODInfo = false;

  }

  showDetails(rowIn: ContainerView) {
    if (rowIn.maherError!=null ) {
      return;
    }
    this.currentIndx = this.inqView.findIndex(xx => xx.container == rowIn.container);
    this.hazardIndx = 0;
    this.historyView = this.contView.filter(xx => xx.container == rowIn.container);
    this.historyView.sort(function(a, b) {
      return new Date(b.time_move).getTime() - new Date(a.time_move).getTime();
    });

    this.quickViewData2 = new MatTableDataSource<ContainerView>(this.historyView);
    this.showQuickView = false;
    this.showDetailScreen = true;
    this.showAcc = false;
    this.clearAllInfo();
    this.cv = null;
    this.cv = {} as ContainerView;
    this.cv = this.historyView[0];
    this.formatDetailScreen();
  }


  showHistoryDetails(rowIn: ContainerView) {
    if (rowIn.maherError!=null) {
      return;
    }
    this.showQuickView = false;
    this.showDetailScreen = true;
    this.showAcc = false;
    this.cv = null;
    this.cv = {} as ContainerView;
    this.cv = rowIn;
    this.formatDetailScreen();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  ngOnInit() {
    this.search1 = new UntypedFormControl();
    this.getListData();
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }
    if (window.innerWidth > 750 && window.innerWidth <1150){
      this.ipadApp = true;
    }
  }

  getListData() {
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];


    this.listData = []
    this.listDataObj = {} as ListData;
    this.listDataObj.type = "E";
    this.listData.push(this.listDataObj);
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.listData;

    const lhsUserObs$ = this.queryService.getLists(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
          this. fillUpSavedLists();
      });

  }


  public wipeOutSearch() {
    this.txtFromArea = null;
    this.showQuickView = false;
    this.showDetailScreen = false;
  }


  getSearchItems() {

    if (this.oneIsInAlready){
      return;
    }
    this.showQuickView = false;
    this.showDetailScreen = false;
    this.submitted = true;
    this.oneIsInAlready = true;
    this.badContainer = false;
    this.badChars = false;
    if (this.txtFromArea == undefined) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }

    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');

    this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
    if (this.txtArray2.length == 0) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }
    this.didntEnterShit = false;
    var _i = this.txtArray2.length;
    while (_i--) {
      this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
      if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
        this.containerNum = this.txtArray2[_i].valueOf();
        this.badChars = true;
        this.oneIsInAlready = false;
        return;
      }

      if (this.txtArray2[_i].valueOf() == "") {
        this.txtArray2.splice(_i, 1);
      }
    }

   this.txtArray2 =  this.service.onlySendOneHundread(this.txtArray2);

    if (this.txtArray2.length<1){
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }


    this.contView = [];
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    for (var items of this.txtArray2) {
      this.cv = {} as ContainerView;
      this.cv.container = items.valueOf();
      if (this.contView.findIndex(xx => xx.container == this.cv.container)==-1){
        this.contView.push(this.cv);
      }
    }
    this.clientRequest.requestData = this.contView;


    const lhsUserObs$ = this.queryService.containerInquiryGetContainers(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (conts) => {
        this.contView = conts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);
          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.inqView = [];
        this.submitted = false;
        this.oneIsInAlready = false;


        if (this.contView!=null){
       /*   this.contView.sort(function(a, b) {
        //    return Number.parseInt(b.unit_gkey) - Number.parseInt(a.unit_gkey)
            return new Date(b.received_date).getTime() - new Date(a.received_date).getTime();

          });
*/
        }

        for (var item of this.contView) {
          if (item.maherError != null) {
            if (item.maherError.toUpperCase()=="UNAUTHORIZED"){
              item.iso_description = "Unauthorized To View Container";
            }else{
              item.iso_description = item.maherError;
            }
          }else{
            if (item.iso_description == null) {
              item.iso_description = " ";
            }
          }
          var indx = this.inqView.findIndex(xx => xx.container == item.container);
          if (indx == -1) {
            this.inqView.push(item);

          }
        }
        this.hazardIndx = 0;

        if (this.inqView.length==1 || window.innerWidth <= 750){
          if (this.inqView[0].maherError!=null) {
            this.badContainer = true;
          }else{
            this.hazardIndx = 0;
            this.clearAllInfo();
            this.historyView = this.contView.filter(xx => xx.container == this.inqView[0].container);
           this.historyView.sort(function(a, b) {
             // return Number.parseInt(b.unit_gkey) - Number.parseInt(a.unit_gkey)
              return new Date(b.time_move).getTime() - new Date(a.time_move).getTime();
            });

            if (window.innerWidth > 750 && window.innerWidth <1150){
              this.ipadAppear = false;
            }

            this.quickViewData2 = new MatTableDataSource<ContainerView>(this.historyView);
            this.cv = this.historyView[0];
            this.formatDetailScreen();
            this.showQuickView = false;
            this.showDetailScreen = true;
          }
        }else {
          if (window.innerWidth > 750 && window.innerWidth <1150){
            this.ipadAppear = false;
          }
          this.showQuickView = true;
          this.showDetailScreen = false;
          this.search1.reset();
          this.quickViewData = new MatTableDataSource<ContainerView>(this.inqView);
        }

      });

    //  }
  }


  returnToQuickView() {
    this.showQuickView = true;
    this.showDetailScreen = false;
  }




  showContainersFromList() {
    var indx = this.listData.findIndex(xx => xx.id == this.savedList);
    if (indx != -1) {
      this.txtFromArea = "";
      for (var ii = 0; ii < this.listData[indx].data.length; ii++) {
        this.txtFromArea = this.txtFromArea + this.listData[indx].data[ii].valueOf() + '\r\n';
      }
    }
  }

  updateContainerList(fromWhere: string){
    this.submitted2 = true;
    this.insertNoConts = false;
    this.insertListExists = false;
    this.noListName = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.listDataObj = null;
    this.listDataObj =  {} as ListData;
    if (fromWhere=="D"){
      var indx = this.listData.findIndex(xx => xx.id == this.savedList);
      if (indx!=-1){
        this.listDataObj = this.listData[indx];
      }
      this.listDataObj.data = [];
      this.clientRequest.requestData = [];
      this.clientRequest.requestData[0] = this.listDataObj;
    }else{
      if (this.txtFromArea==undefined || this.txtFromArea==""){
        if (fromWhere=="I" || fromWhere=="U"){
          this.insertNoConts = true;
        }
        return;
      }
      if (fromWhere=="I" && (this.myNewListName==null || this.myNewListName=="")){
        this.noListName = true;
        return;
      }


      if ((fromWhere=="U" ) && (this.savedList==null || this.savedList=="")){
        this.noListName = true;
        return;
      }

      if (fromWhere=="I" &&  this.listData.findIndex(xx => xx.name == this.myNewListName && xx.type == "E") !=-1){
        this.insertListExists = true;
        return;
      }


      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length==0){
        this.didntEnterShit = true;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }
      }

      if (fromWhere!="D"){
        if (fromWhere=="I"){
          this.listDataObj.name = this.myNewListName;
          this.listDataObj.type = "E";
        }else{
          var indx = this.listData.findIndex(xx => xx.id == this.savedList);
          if (indx!=-1){
            this.listDataObj = this.listData[indx];
          }
        }
        this.listDataObj.data = this.txtArray2;
        this.clientRequest.requestData = [];
        this.clientRequest.requestData[0] = this.listDataObj;
      }
    }

    this.clientRequest.user = this.myUser;

    const lhsUserObs$ = this.queryService.updateContainerList(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        var id = this.savedList;
        this.fillUpSavedLists();
        if (this.savedLists.length > 0) {
          if (fromWhere == "I") {
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.code == this.myNewListName)].id;
          } else if (fromWhere== "D") {
            this.savedList = this.savedLists[0].id;
          }else{
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.id == id)].id;
          }
        }
        this.myNewListName = "";

        if (fromWhere=="I"){
          this.myApp.showSuccessBanner("","the new list has been created successfully","equipInq");
        }else if (fromWhere=="D"){
          this.myApp.showSuccessBanner("",this.myNewListName + " has been deleted successfully","equipInq");
        }else{
          this.myApp.showSuccessBanner("","List has been updated successfully","equipInq");

        }

        this.submitted2= false;

      });

  }


  fillUpSavedLists(){
    this.savedLists = [];
    for (var item of this.listData){
      if (item.type =="E"){
        this.savedLists.push({"id": item.id, "code": item.name, "description": item.name});
      }
    }
    if (this.savedLists.length>0){
      this.savedList = this.savedLists[0].id;
    }
  }


  previousContainer() {
    this.currentIndx--;
    if (this.currentIndx >= 0) {
      for (var dd = this.currentIndx; dd < this.inqView.length; dd--) {
        if (this.inqView[dd].maherError!=null ) {
          this.currentIndx--;
        } else {
          break;
        }
      }
      this.historyView = this.contView.filter(xx => xx.container == this.inqView[this.currentIndx].container);
      this.historyView.sort(function(a, b) {
        return new Date(b.time_move).getTime() - new Date(a.time_move).getTime();
      });
      this.quickViewData2 = new MatTableDataSource<ContainerView>(this.historyView);

      this.cv = null;
      this.cv = {} as ContainerView;
      this.cv = this.historyView[0];
      this.showAcc = false;
      this.formatDetailScreen();
    } else {
      this.currentIndx = 0;
    }

  }

  nextContainer() {
    this.currentIndx++;
    if (this.currentIndx < this.inqView.length) {
      for (var dd = this.currentIndx; dd < this.inqView.length; dd++) {
        if (this.inqView[dd].maherError!=null ) {
          this.currentIndx++;
        } else {
          break;
        }
      }

      this.historyView = this.contView.filter(xx => xx.container == this.inqView[this.currentIndx].container);
      this.historyView.sort(function(a, b) {
        return new Date(b.time_move).getTime() - new Date(a.time_move).getTime();
      });
      this.quickViewData2 = new MatTableDataSource<ContainerView>(this.historyView);

      this.cv = null;
      this.cv = {} as ContainerView;
      this.cv = this.historyView[0];
      this.showAcc = false;
      this.formatDetailScreen();
    } else {


      this.currentIndx = this.inqView.length - 1;
      var _i = this.inqView.length;
      while (_i--) {
        if (this.inqView[_i].maherError!=null ) {
        } else {
          this.currentIndx = _i;
          break;
        }
      }
    }
  }


  nextHazard(){
    this.hazardIndx++;
    if (this.hazardIndx<this.cv.hazardsArray.length){
      this.haz = null;
      this.haz = {} as HazardsView;
      this.haz = this.cv.hazardsArray[this.hazardIndx];
      this.formatHazards(this.hazardIndx);
    }else{
      this.hazardIndx=this.cv.hazardsArray.length-1;
    }
  }

  previousHazard(){
    this.hazardIndx--;
    if (this.hazardIndx>=0){
      this.haz = null;
      this.haz = {} as HazardsView;
      this.haz = this.cv.hazardsArray[this.hazardIndx];
      this.formatHazards(this.hazardIndx);
    }else{
      this.hazardIndx=0;
    }


  }

  getNiceDate(dateIn: string): string {
    this.date1 = new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options);
  }




  getNiceWeight(weightIn: string): string {
    this.number1 = Number.parseInt(weightIn);
    return this.number1.toLocaleString("en-US", this.options2);
  }



  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }

  deleteHit() {
    this.myApp.showConfirmBanner("Confirm","confirm delete of list: "+this.savedLists[this.savedLists.findIndex(xx=>xx.id==this.savedList)].description,"equipInq");
    return;
  }


  formatDetailScreen() {


    if (this.cv.container == null) {
      this.cv.container = " ";
    }
    if (this.cv.line_description == null) {
      this.cv.line_description = " ";
    }
    if (this.cv.freight_kind_description == null) {
      this.cv.freight_kind_description = " ";
    }
    if (this.cv.iso_description == null) {
      this.cv.iso_description = " ";
    }

    if (this.cv.ssl_owner_description == null) {
      this.cv.ssl_owner_description = " ";
    }
    if (this.cv.lease_description == null) {
      this.cv.lease_description = " ";
    }
    if (this.cv.group_code == null) {
      this.cv.group_code = " ";
    }
    if (this.cv.location == null) {
      this.cv.location = " ";
    }
    if (this.cv.gross_weight == null || this.cv.gross_weight == "0") {
      this.cv.gross_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.cv.gross_weight);
      this.cv.gross_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.cv.gross_weight_lbs);
      this.cv.gross_weightFmt = this.cv.gross_weightFmt + this.weight + " lbs";
    }
    if (this.cv.tare_weight == null || this.cv.tare_weight == "0") {
      this.cv.tare_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.cv.tare_weight);
      this.cv.tare_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.cv.tare_weight_lbs);
      this.cv.tare_weightFmt = this.cv.tare_weightFmt + this.weight + " lbs";
    }


    if (this.cv.cargo_weight == null || this.cv.cargo_weight == "0") {
      this.cv.cargo_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.cv.cargo_weight);
      this.cv.cargo_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.cv.cargo_weight_lbs);
      this.cv.cargo_weightFmt = this.cv.cargo_weightFmt + this.weight + " lbs";
    }


    if (this.cv.seal_1 == null) {
      this.cv.seal_1 = " ";
    }
    if (this.cv.seal_2 == null) {
      this.cv.seal_2 = " ";
    }
    if (this.cv.seal_3 == null) {
      this.cv.seal_3 = " ";
    }
    if (this.cv.seal_4 == null) {
      this.cv.seal_4 = " ";
    }

    if (this.cv.booking == null) {
      this.cv.booking = " ";
    }
    if (this.cv.booking_line_description == null) {
      this.cv.booking_line_description = " ";
    }
    if (this.cv.grade_description == null) {
      this.cv.grade_description = " ";
    }
    if (this.cv.remarks == null) {
      this.cv.remarks = " ";
    }
    if (this.cv.over_height == null) {
      this.cv.over_heightFmt = " ";
    } else {
      this.cv.over_heightFmt = this.cv.over_height + " cm / ";
      if (this.cv.over_height_in!=null){
        this.cv.over_heightFmt = this.cv.over_heightFmt + this.cv.over_height_in + " in"
      }
    }

    if (this.cv.over_length_front == null) {
      this.cv.over_length_frontFmt = " ";
    } else {
      this.cv.over_length_frontFmt = this.cv.over_length_front + " cm / ";
      if (this.cv.over_length_front_in!=null){
        this.cv.over_length_frontFmt = this.cv.over_length_frontFmt + this.cv.over_length_front_in + " in"
      }
    }
    if (this.cv.over_length_rear == null) {
      this.cv.over_length_rearFmt = " ";
    } else {
      this.cv.over_length_rearFmt = this.cv.over_length_rear + " cm / ";
      if (this.cv.over_length_rear_in!=null){
        this.cv.over_length_rearFmt = this.cv.over_length_rearFmt + this.cv.over_length_rear_in + " in"
      }
    }
    if (this.cv.over_width_left == null) {
      this.cv.over_width_leftFmt = " ";
    } else {
      this.cv.over_width_leftFmt = this.cv.over_width_left + " cm / ";
      if (this.cv.over_width_left_in!=null){
        this.cv.over_width_leftFmt = this.cv.over_width_leftFmt + this.cv.over_width_left_in + " in"
      }
    }
    if (this.cv.over_width_right == null) {
      this.cv.over_width_rightFmt = " ";
    } else {
      this.cv.over_width_rightFmt = this.cv.over_width_right + " cm / ";
      if (this.cv.over_width_right_in!=null){
        this.cv.over_width_rightFmt = this.cv.over_width_rightFmt + this.cv.over_width_right_in + " in"
      }
    }

   if (this.cv.category==null){
     this.cv.hazardousFmt = " ";
   }else  if (this.cv.hazardous == null || this.cv.hazardous == "0") {
      this.cv.hazardousFmt = "No";
    } else {
      this.cv.hazardousFmt = "Yes";
    }

    if (this.cv.category==null){
      this.cv.is_oogFmt = " ";
    }else if (this.cv.is_oog==null || this.cv.is_oog == "0"  ) {
      this.cv.is_oogFmt = "No";
    } else {
      this.cv.is_oogFmt = "Yes";
    }

    if (this.cv.category == null) {
      this.cv.requires_powerFmt = " ";
    }else if (this.cv.requires_power == null || this.cv.requires_power == "0") {
      this.cv.requires_powerFmt = "No";
    } else {
      this.cv.requires_powerFmt = "Yes";
    }

    if (this.cv.holds == "0") {
      this.cv.holdsFmt = "No";
    } else {
      this.cv.holdsFmt = "Yes";
    }
    if (this.cv.in_vessel_description == null) {
      this.cv.in_vessel_description = " ";
    }
    if (this.cv.out_vessel_description == null) {
      this.cv.out_vessel_description = " ";
    }
    if (this.cv.in_voyage == null) {
      this.cv.in_voyage = " ";
    }
    if (this.cv.out_voyage == null) {
      this.cv.out_voyage = " ";
    }

    if (this.cv.port_of_loading_description == null) {
      this.cv.port_of_loading_description = " ";
    }


    if (this.cv.last_pos_name == null) {
      this.cv.last_pos_name = " ";
    }
    if (this.cv.received_date_fmt == null) {
      this.cv.received_date_fmt = " ";
    }
    if (this.cv.fte_date == null) {
      this.cv.fte_date = " ";
    }

    if (this.cv.dwell_days == null) {
      this.cv.dwell_days = " ";
    }


    if (this.cv.delivered_date == null) {
      this.cv.delivered_date_fmt = " ";
    }

    if (this.cv.inbound_mode== null) {
      this.cv.inbound_mode = " ";
    }
    if (this.cv.outbound_mode == null) {
      this.cv.outbound_mode = " ";
    }
    if (this.cv.out_visit == null) {
      this.cv.out_visit = " ";
    }
    if (this.cv.in_visit == null) {
      this.cv.in_visit = " ";
    }
    if (this.cv.in_trucking_co_description == null) {
      this.cv.in_trucking_co_description = " ";
    }
    if (this.cv.out_trucking_co_description == null) {
      this.cv.out_trucking_co_description = " ";
    }

    if (this.cv.in_driver_name == null) {
      this.cv.in_driver_name = " ";
    }
    if (this.cv.out_driver_name == null) {
      this.cv.out_driver_name = " ";
    }


    if (this.cv.genset_requirement == null) {
      this.cv.genset_requirement = " ";
    }

    if (this.cv.vent_required_pct == null) {
      this.cv.vent_required_pct = " ";
    }
    if (this.cv.vent_unit_description == null) {
      this.cv.vent_unit_description = " ";
    }
    if (this.cv.humidity_required_pct == null) {
      this.cv.humidity_required_pct = " ";
    }

    if (this.cv.temp_reqd_f == null) {
      this.cv.temp_reqdFmt = " ";
    } else {
      if (this.cv.temp_reqd_f != null) {
        this.cv.temp_reqdFmt = this.cv.temp_reqd_f + "F / ";
      }
      if (this.cv.temp_reqd_c != null) {
        this.cv.temp_reqdFmt = this.cv.temp_reqdFmt  + this.cv.temp_reqd_c + "C";
      }
    }


    this.hArray = [];

    if (this.cv.holdsArray != null) {
      if (this.cv.holdsArray.length > 0) {
        for (var item2 of this.cv.holdsArray) {
          this.hold = {} as HoldsView;
          this.hold.type = item2.type
          this.hold.code = item2.code
          this.hold.description = item2.description;
          this.hArray.push(this.hold);
        }

      }
    }
    if (this.cv.hazardsArray!=null) {
      if (this.cv.hazardsArray.length > 0) {
        this.formatHazards(0);
      }
    }

    this.holdsData = new MatTableDataSource<HoldsView>(this.hArray);







  }

  formatHazards(indxIn: number){
    if (indxIn==0){
      this.haz = {} as HazardsView;
      if (this.cv.hazardsArray!=null) {
        if (this.cv.hazardsArray.length > 0) {
          this.haz = this.cv.hazardsArray[0];
        }
      }
    }
    if (this.haz.imdg_class == null) {
      this.haz.imdg_class = " ";
    }

    if (this.haz.imdg_description == null) {
      this.haz.imdg_description = " ";
    }

    this.haz.imdgConcat = this.haz.imdg_class + " - " + this.haz.imdg_description;


    if (this.haz.proper_name == null) {
      this.haz.proper_name = " ";
    }
    if (this.haz.hzrdi_nbr_type == null) {
      this.haz.hzrdi_nbr_type = " ";
    }
    if (this.haz.quantity == null) {
      this.haz.quantity = " ";
    }
    if (this.haz.package_type == null) {
      this.haz.package_type = " ";
    }

    if (this.haz.weight == null || this.haz.weight == "0") {
      this.haz.weightDisp = " ";
    } else {
      this.weight = this.getNiceWeight(this.haz.weight);
      this.haz.weightDisp =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.haz.weight_lbs);
      this.haz.weightDisp = this.haz.weightDisp + this.weight + " lbs";
    }


    if (this.haz.marine_pollutants == '0') {
      this.haz.marine_pollutants = "No";
    } else {
      this.haz.marine_pollutants = "Yes";
    }
    if (this.haz.tech_name == null) {
      this.haz.tech_name = " ";
    }
    if (this.haz.undg == null) {
      this.haz.undg = " ";
    }
    if (this.haz.hzrdi_nbr_type == null) {
      this.haz.hzrdi_nbr_type = " ";
    }
    this.haz.undgTypeConcat = this.haz.undg + " - " + this.haz.hzrdi_nbr_type;

    if (this.haz.flashpoint_f == null){
      this.haz.flashpoint_fmt = " ";
    }else{
      if (this.haz.flashpoint_f!=null){
        this.haz.flashpoint_fmt = this.haz.flashpoint_f+"F";
      }
      if (this.haz.flashpoint_c!=null){
        this.haz.flashpoint_fmt = this.haz.flashpoint_fmt + " / "+this.haz.flashpoint_c+"C";
      }
    }

    if (this.haz.package_group == null) {
      this.haz.package_group = " ";
    }
    if (this.haz.emergency_telephone_fmt == null) {
      this.haz.emergency_telephone_fmt = " ";
    }
    if (this.haz.notes == null) {
      this.haz.notes = " ";
    }

    }



}
